module.exports = __webpack_public_path__ + "img/cp-bg-l.5662182a.png";